module.exports = __webpack_public_path__ + "img/contactUs-desc.d94c16a5.png";